<template>
  <div :class="{ 'modal-open': showModal }">
    <div class="my-app home-two-dark">
      <Header2 class="header--dark" />
      <MobileMenu />
      <section class="section team-main pb-0">
        <div
          class="min-h-screen flex flex-col justify-center items-center px-4 py-4"
        >
          <div class="button-container mb-4">
            <button @click="openModal('create')" class="btn-one">
              {{ labelsState["appointment_new"] || "New Appointment" }}
            </button>
            <!--
            <button @click="openModal('edit')" class="btn-one">
              {{ labelsState["appointment_change"] || "Change Appointment" }}
            </button>
            -->
            <button @click="openModal('delete')" class="btn-one">
              {{ labelsState["appointment_cancel"] || "Cancel Appointment" }}
            </button>
          </div>
          <div class="container">
            <p class="text-xl">
              {{
                labelsState["appointment_calendar"] || "Appointment Calendar"
              }}
            </p>
            <div class="row items-gap align-items-center">
              <p class="fw-5 text-md">
                {{
                  labelsState["appoint_message"] ||
                  "Welcome to our appointment system. We invite you to select your preferred time slot. It will be our pleasure to assist you!"
                }}
              </p>
              <div
                class="team-main-single wow fadeInLeft"
                data-wow-duration="600ms"
                data-wow-delay="300ms"
              >
                <div class="flex justify-center m-4 rounded calendar-container">
                  <iframe
                    :src="calendarUrl"
                    class="rounded calendar-iframe"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-popup">
            <div
              v-if="isLoading"
              class="absolute inset-0 bg-black/50 flex flex-col items-center justify-center z-50"
            >
              <div class="spinner"></div>
              <p class="mt-3 text-white font-semibold">{{ labelsState["loading"] || "Loading"}}...</p>
            </div>

            <h2 class="modal-header">{{ modalTitle }}</h2>
            <div class="modal-body">
              <form @submit.prevent="handleSubmit" class="flex flex-col gap-3">
                  <div
                    v-if="modalAction === 'create'"
                    class="flex flex-col gap-4"
                  >
                    <p class="modal-info-text">
                      {{
                        labelsState["appointment_create"] ||
                        "To schedule your appointment, select an available date and time according to the main calendar, complete your details and confirm your reservation, remember between 12 PM and 1 PM Colombia time the team is not available."
                      }}
                    </p>
                    <div class="form-group">
                      <label for="user_name">{{
                        labelsState["user_name"] || "User Name"
                      }}</label>
                      <input
                        v-model="formDataResult.user_name"
                        type="text"
                        id="user_name"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label for="user_email">{{
                        labelsState["user_email"] || "User Email"
                      }}</label>
                      <input
                        v-model="formDataResult.user_email"
                        type="email"
                        id="user_email"
                        required
                      />
                    </div>

                    <div class="form-group flex items-center">
                      <div class="mr-2 w-1/4">
  <label for="country-code">{{
    labelsState["indicative"] || "Indicative"
  }} +</label>
  <div class="form-group">
  <select
    v-model="countryCode"
    id="country-code"
    class="w-full"
    required
  >
    <option v-for="country in sortedCountries" 
            :key="country.phoneCode" 
            :value="country.phoneCode">
      {{ country.phoneCode }} {{ country.countryCode }}
    </option>
  </select>
</div>
</div>
                    <div class="flex-grow">
                      <label for="phone">{{
                        labelsState["user_phone"] || "User Phone"
                      }}</label>
                      <input
                        v-model="phoneNumber"
                        type="number"
                        id="phone"
                        placeholder="0000000000"
                        class="w-full"
                        required
                      />
                    </div>
                    </div>

                    <div class="form-group">
                      <label for="start_time">{{
                        labelsState["time_colombia"] ||
                        "Date and Time (Colombia Time)"
                      }}</label>

                    <div>
                      <DatePicker
                        v-model="formDataResult.start_time"
                        type="datetime"
                        format="YYYY-MM-DD HH:mm"
                        :disabled-date="disabledDate"
                        :time-picker-options="timePickerOptions"
                        :minute-step="30"
                        :placeholder="labelsState['time_colombia_date'] || 'Date and Time (Colombia Time)'"
                        class="date-picker"
                        @change="checkAvailability"
                      />
                    </div>

                    </div>
                    <div class="button-container p-2 mx-5">
                      <button
                        type="submit"
                        class="btn add-button montserrat-discontinuo"
                        :disabled="isLoading"
                      >
                        {{ labelsState["save"] || "Save" }}
                      </button>
                      <button
                        type="button"
                        class="btn custom-button montserrat-discontinuo"
                        :disabled="isLoading"
                        @click="closeModal"
                      >
                        {{ labelsState["cancel"] || "Cancel" }}
                      </button>
                    </div>
                  </div>

                  <div v-else class="flex flex-col gap-4">
                    <div class="flex flex-col gap-4">
                      <p class="modal-info-text">
                        {{ labelsState["appointment_reference"] || "Enter your reference and email to cancel the appointment." }}
                      </p>
                      <div class="form-group">
                        <label for="reference">{{ labelsState["reference"] || "Reference Number" }}</label>
                        <input v-model="formDataFetch.reference" type="text" id="reference" required />
                      </div>
                      <div class="form-group">
                        <label for="email">{{ labelsState["user_email"] || "User Email" }}</label>
                        <input v-model="formDataFetch.user_email" type="email" id="email" required />
                      </div>
                      <div class="button-container p-2 mx-5">
                        <button
                          type="button"
                          class="btn add-button montserrat-discontinuo"
                          @click="fetchAppointmentDetails"
                        >
                          {{ labelsState["cancel_appoint"] || "Cancel Appointment" }}
                        </button>
                      </div>
                    </div>
                    <template v-if="isQueryDone">
                      <p v-if="modalAction === 'edit'" class="modal-info-text">
                        {{
                          labelsState["appointment_confirm_edit"] ||
                          "The following appointment is selected for editing:"
                        }}
                      </p>
                      <p
                        v-if="modalAction === 'delete'"
                        class="modal-info-text"
                      >
                        {{
                          labelsState["confirm_delete"] ||
                          "The following appointment is scheduled to be canceled:"
                        }}
                      </p>
                      <div class="form-group">
                        <label>{{
                          labelsState["reference"] || "Reference"
                        }}</label>
                        <p>{{ formDataResult.reference }}</p>
                      </div>
                      <div class="form-group">
                        <label>{{ labelsState["details"] || "Details" }}</label>
                        <p v-html="formDataResult.description"></p>
                      </div>
                      <div class="form-group">
                        <label>{{ labelsState["user_phone"] || "User Phone" }}</label>
                        <input v-model="formDataResult.phone" type="text" id="phone" />
                      </div>
                      <div class="form-group">
                        <label>{{
                          labelsState["time_colombia"] ||
                          "Date and Time (Colombia Time)"
                        }}</label>
                        <p>
                          {{
                            formatDateToColombiaTime(formDataResult.start_time)
                          }}
                        </p>
                      </div>

                      <div v-if="modalAction === 'edit'">

                        <div class="form-group">
                          <label for="start_time">{{
                            labelsState["time_colombia"] ||
                            "Date and Time (Colombia Time)"
                          }}</label>

<div class="form-group">
  <DatePicker
    v-model="formDataResult.start_time"
    type="datetime"
    format="YYYY-MM-DD HH:mm"
    :disabled-date="disabledDate"
    :time-picker-options="timePickerOptions"
    :minute-step="30"
    placeholder="Selecciona fecha y hora"
    class="date-picker"
    @change="checkAvailability"
  />
</div>

                        </div>
                        <div class="button-container p-2 mx-5">
                          <button
                            type="submit"
                            class="btn add-button montserrat-discontinuo"
                            :disabled="isLoading"
                          >
                            {{ labelsState["save"] || "Save" }}
                          </button>
                          <button
                            type="button"
                            class="btn custom-button montserrat-discontinuo"
                            :disabled="isLoading"
                            @click="closeModal"
                          >
                            {{ labelsState["cancel"] || "Cancel" }}
                          </button>
                        </div>
                      </div>

                      <div v-if="modalAction === 'delete'">
                        <div class="button-container p-2 mx-5">
                          <button
                            type="submit"
                            class="btn add-button montserrat-discontinuo"
                            :disabled="isLoading"
                            @click="deleteAppointment"
                          >
                            {{
                              labelsState["cancel_appoint"] ||
                              "Cancel Appointment"
                            }}
                          </button>
                          <button
                            type="button"
                            class="btn custom-button montserrat-discontinuo"
                            :disabled="isLoading"
                            @click="closeModal"
                          >
                            {{
                              labelsState["keep_appoint"] || "Keep Appointment"
                            }}
                          </button>
                        </div>
                      </div>
                    </template>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer2 />
    </div>
    <BackToTop />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { computed, ref, onMounted } from "vue";
import { useLabelsStore } from "@/stores/labels";
import { useLanguageStore } from "@/stores/language";
import "../assets/css/global.css";
import axios from "axios";
import Swal from "sweetalert2";
import { pixel } from '@/plugins/metaPixel'
import Header2 from "../components/layout/Header2.vue";
import MobileMenu from "../components/layout/MobileMenu.vue";
import Footer2 from "../components/layout/Footer2.vue";
import BackToTop from "../components/common/BackToTop.vue";

export default {
  name: "CalendarSection",
  components: { Header2, MobileMenu, Footer2, BackToTop,DatePicker  },
  setup() {
    const isLoading = ref(false);
    const disabledDate = (date) => {
      const day = date.getDay();
      return day === 0 || day === 6;
    };
    const timePickerOptions = {
      start: "09:00",
      end: "18:00",
      step: "00:30", 
    };
    const refCode = ref('');
    const countryCode = ref("");
    const phoneNumber = ref("");
    const urlParams = ref({});
    const labelsStore = useLabelsStore();
    const labelsState = computed(() => labelsStore.labels);
    const showModal = ref(false);
    const modalAction = ref("");
    const calendarUrl = "https://outlook.office365.com/owa/calendar/ce022cbc69cd4b009ba08c6a2b48455d@nqartificial.com/e378e806786246bd9fdcccb2673325a217946270446094409735/calendar.html"
    labelsState.value["calendar_link"] ||
      "https://outlook.office365.com/owa/calendar/ce022cbc69cd4b009ba08c6a2b48455d@nqartificial.com/e378e806786246bd9fdcccb2673325a217946270446094409735/calendar.html";
    const isQueryDone = ref(false);
    const formDataResult = ref({
      user_email: "",
      user_name: "",
      phone: "",
      start_time: "",
      description: "",
      reference: "",
    });
    const formDataFetch = ref({ reference: "", user_email: "" });
    function formatDateToColombiaTime(dateString) {
      const utcDate = new Date(dateString);
      return new Intl.DateTimeFormat("es-CO", {
        timeZone: "America/Bogota",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZoneName: "short",
      }).format(utcDate);
    }
    function formatDateToDatetimeLocal(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    const modalTitle = computed(() => {
    return modalAction.value === "create"
    ? labelsState.value["appointment_new"] || "New Appointment"
    : modalAction.value === "edit"
    ? labelsState.value["appointment_change"] || "Change Appointment"
    : labelsState.value["cancel_appoint"] || "Cancel Appointment";
});

    const openModal = (action) => {
      modalAction.value = action;
      showModal.value = true;
      resetForm();
    };
    const closeModal = () => {
      showModal.value = false;
      isQueryDone.value = false;
      resetForm();
    };
    const resetForm = () => {
      formDataResult.value = {
        user_email: "",
        user_name: "",
        start_time: "",
        description: "",
        reference: "",
      };
      countryCode.value = "";
      phoneNumber.value = "";
      formDataFetch.value = { reference: "", user_email: "" };
    };
    const handleSubmit = async () => {
      if (modalAction.value === "create") {
        await createAppointment();
      } else if (modalAction.value === "edit") {
        await editAppointment();
      } else {
        await deleteAppointment();
      }
      closeModal();
    };
    const fetchAppointmentDetails = async () => {
      isLoading.value = true;
      try {
        const confirmResult = await Swal.fire({
          title: labelsState.value["sure"] || "Are you sure?",
          text: labelsState.value["confirm_delete"] || "This action cannot be undone.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: labelsState.value["cancel_appoint"] || "Cancel Appointment",
          cancelButtonText: labelsState.value["keep_appoint"] || "Keep Appointment",
          padding: "2em",
          customClass: {
            confirmButton: "btn add-button montserrat-discontinuo",
            cancelButton: "btn custom-button montserrat-discontinuo",
            actions: "swal2-buttons",
          },
          buttonsStyling: false,
        });

        if (!confirmResult.isConfirmed) {
          isLoading.value = false;
          return;
        }
        const queryString = new URLSearchParams(urlParams.value).toString();
        const response = await axios.delete(
          `${process.env.VUE_APP_HOST_WHATSAPP}/appointment/user/${formDataFetch.value.reference}/${formDataFetch.value.user_email}${queryString ? `?${queryString}` : ''}`
        );
        if (response.status === 200) {
      Swal.fire({
        icon: "success",
        title: labelsState.value["success"] || "Success",
        text: response.data.message || "Appointment cancelled successfully.",
      });

      // Limpiar formulario y cerrar modal si deseas
      resetForm();
      showModal.value = false;
    }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: labelsState.value["error"] || "Error",
          text:
            error.response?.data?.error ||
            labelsState.value["error_detail"] || "Failed to fetch details.",
        });
      }
      finally {
        isLoading.value = false;
      }
    };
    const deleteAppointment = async () => {
    isLoading.value = true;
    try {
      const reference = formDataResult.value.reference;
      const user_email = formDataResult.value.user_email;
      const result = await Swal.fire({
        title: labelsState.value["sure"] || "Are you sure?",
        text: labelsState.value["confirm_delete"] || "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          labelsState.value["cancel_appoint"] || "Cancel Appointment",
        cancelButtonText: labelsState.value["keep_appoint"] || "Keep Appointment",
        padding: "2em",
        customClass: {
          confirmButton: "btn add-button montserrat-discontinuo",
          cancelButton: "btn custom-button montserrat-discontinuo",
          actions: "swal2-buttons",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        const queryString = new URLSearchParams(urlParams.value).toString();
        await axios.delete(
          `${process.env.VUE_APP_HOST_WHATSAPP}/appointment/delete/${reference}/${user_email}${queryString ? `?${queryString}` : ''}`
        );
        Swal.fire({ icon: "success", title: "Appointment Deleted" });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: labelsState.value["error"] || "Error",
        text: error.response?.data?.error || "Failed to delete appointment.",
      });
    } finally {
      isLoading.value = false;
    }
  };
    const editAppointment = async () => {
      isLoading.value = true;
      formDataResult.value.phone = `${countryCode.value}${phoneNumber.value}`;
      try {
        const localDateTime = new Date(`${formDataResult.value.start_time}:00`);
        const response = await axios.put(
          `${process.env.VUE_APP_HOST_WHATSAPP}/appointment/modify`,
          {
            user_email: formDataResult.value.user_email,
            reference: formDataResult.value.reference,
            new_start_time: localDateTime.toISOString(),
            new_description: formDataResult.value.description,
            phone: [formDataResult.value.phone],
            ...urlParams.value
          },
          { headers: { "Content-Type": "application/json" } }
        );

        const referenceNumber = response.data.reference;
        Swal.fire({
          icon: "success",
          title:
            labelsState.value["success_update_appointment"] ||
            "Appointment Changed Successfully",
            text: `${labelsState.value["copy_number_reference"] || "Your appointment was successfully modified. Please save this reference:"}\n\nReference Number: ${referenceNumber}\n\n`,
          showCloseButton: true,
          confirmButtonText: labelsState.value["copy"] || "Copy",
          customClass: {
            confirmButton: "btn add-button montserrat-discontinuo",
            actions: "swal2-buttons",
          },
          buttonsStyling: false,
          didOpen: () => {
            Swal.getConfirmButton().addEventListener("click", () => {
              navigator.clipboard.writeText(response.data.reference);
              Swal.fire(
                labelsState.value["copied"] || "Copied!",
                labelsState.value["copied_reference"] ||
                  "Reference number copied to clipboard",
                "success"
              );
            });
          },
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: labelsState.value["error"] || "Error",
          text: error.response?.data?.error ||
          labelsState.value["error_modify_appointment"] || "Failed to update appointment."
        });
      }
      finally {
        isLoading.value = false;
      }
    };

    const createAppointment = async () => {
    isLoading.value = true;
    formDataResult.value.phone = `${countryCode.value}${phoneNumber.value}`;
    try {
      const localDateTime = new Date(formDataResult.value.start_time);
      const formattedStartTime = localDateTime.toISOString().split('.')[0];
      const requestData = {
        user_email: formDataResult.value.user_email,
        user_name: formDataResult.value.user_name,
        phone: formDataResult.value.phone,
        start_time: formattedStartTime,
        description: formDataResult.value.description,
        attendees: [formDataResult.value.user_email],
        ...urlParams.value
      };

      if (refCode.value) {
        requestData.refcode = refCode.value;
      }
      const queryString = new URLSearchParams(urlParams.value).toString();

      const response = await axios.post(
        `${process.env.VUE_APP_HOST_WHATSAPP}/appointment/create${queryString ? `?${queryString}` : ''}`,
        requestData,
        { headers: { "Content-Type": "application/json" } }
      );
      
      const referenceNumber = response.data.appointment.reference;
      pixel.lead({ name: 'Cita NQArtificial', category: 'Appointment' })
      Swal.fire({
        icon: "success",
        title:
          labelsState.value["success_create_appointment"] ||
          "Appointment Created Successfully",
        text: `${
          labelsState.value["copy_number_reference"] ||
          "Your appointment was successfully created. Please save this reference, this number will allow you to manage your scheduled appointment."
        }\n\nReference Number: ${referenceNumber}\n\n`,
          
        showCloseButton: true,
        confirmButtonText: labelsState.value["copy"] || "Copy",
        customClass: {
          confirmButton: "btn add-button montserrat-discontinuo",
          actions: "swal2-buttons",
        },
        buttonsStyling: false,
        didOpen: () => {
          Swal.getConfirmButton().addEventListener("click", () => {
            navigator.clipboard.writeText(response.data.appointment.reference);
            Swal.fire(
              labelsState.value["copied"] || "Copied!",
              labelsState.value["copied_reference"] ||
                "Reference number copied to clipboard",
              "success"
            );
          });
        },
      });
    } 
    catch (error) {
      if (
        error.response &&
        error.response.data.error === "Appointment slot is already booked"
      ) {
        Swal.fire({
          icon: "error",
          title: labelsState.value["error"] || "Error",
          text:
            labelsState.value["slot_unavailable"] ||
            "The selected time is not available. Please select another time based on the availability of the main calendar. Remember between 12 PM and 1 PM the team is not available.",
          confirmButtonText: labelsState.value["ok"] || "OK",
          customClass: {
            confirmButton: "btn add-button montserrat-discontinuo",
            actions: "swal2-buttons",
          },
          buttonsStyling: false,
        });
      } else {      
        Swal.fire({
          icon: "error",
          title: labelsState.value["error"] || "Error",
          text:
            error.response?.data?.error ||
            labelsState.value["error_add_appointment"] ||
            "An error occurred while creating the appointment.",
          confirmButtonText: labelsState.value["ok"] || "OK",
          customClass: {
            confirmButton: "btn add-button montserrat-discontinuo",
            actions: "swal2-buttons",
          },
          buttonsStyling: false,
        });
      }
    }
    finally {
      isLoading.value = false;
    }
  };

const countries = ref([]);

const sortedCountries = computed(() => {
  return [...countries.value].sort((a, b) => {
    const phoneCodeA = parseInt(a.phoneCode.replace('+', ''));
    const phoneCodeB = parseInt(b.phoneCode.replace('+', ''));
    return phoneCodeA - phoneCodeB;
  });
});

const fetchCountries = async () => {
  try {
    const response = await axios.get(`${process.env.VUE_APP_HOST_ROLESANDADMINISTRATION}/countries`);
    countries.value = response.data.countries;
    
    if (countries.value.length > 0 && !countryCode.value) {
      countryCode.value = sortedCountries.value[0].phoneCode;
    }
  } catch (error) {
    console.error('Error fetching countries:', error);
  }
};


onMounted(async () => {
  await fetchCountries();
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach((value, key) => {
    urlParams.value[key] = value;
  });
  
  if (searchParams.has('refcode')) {
    refCode.value = searchParams.get('refcode');
    console.log('RefCode detectado:', refCode.value);
  }
  
  if (searchParams.has('modal')) {
    const modalType = searchParams.get('modal');
    if (['create', 'edit', 'delete'].includes(modalType)) {
      openModal(modalType);
    }
  }
});

    return {
      countries,
      sortedCountries,
      fetchCountries,
      countryCode,
      phoneNumber,
      isLoading,
      labelsState,
      calendarUrl,
      showModal,
      modalAction,
      isQueryDone,
      formDataFetch,
      modalTitle,
      openModal,
      closeModal,
      handleSubmit,
      createAppointment,
      editAppointment,
      deleteAppointment,
      fetchAppointmentDetails,
      formatDateToColombiaTime,
      disabledDate,
      timePickerOptions,
      formDataResult,
      urlParams,
    };
  },
};
</script>

<style scoped>

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-body {
  position: relative;
}

.spinner {
  width: 64px;
  height: 64px;
  border: 6px solid #3b82f6;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.calendar-container {
  width: 100%;
  height: 650px;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  margin: 2px;
  background: #192337;
}
.calendar-iframe {
  width: 100%;
  height: 100%;
  border: 2px solid #111827;
  transform: scale(0.87);
}


.button-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-one {
  padding: 10px 20px;
  border: 2px solid #fff;
  border-radius: 50px;
  background-color: transparent;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px; 
  text-align: center; 
}

.btn-one:hover {
  border: 2px solid #00cc99;
  color: #00cc99;
  transform: scale(1.05);
  background-color: rgba(0, 204, 153, 0.1);
}


.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(246, 242, 242, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 10px;
}

.modal-popup {
  background-color: #0e1726;
  border-radius: 10px;
  width: 90%; 
  max-width: 500px;
  padding: 20px;
  position: relative;
  z-index: 10000;
  animation: fadeIn 0.3s ease-in-out;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.modal-header {
  text-align: center;
  background-color: #0e1726;
  color: white;
  font-size: 1.5em;
  padding: 10px;
  border-radius: 10px 10px 0 0;
  margin-bottom: 20px;
}

.modal-body {
  color: #d9d9d9;
  font-size: 1em;
  overflow-y: auto;
  flex: 1;
  padding-right: 5px;
}

.modal-body::-webkit-scrollbar {
  width: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: #1e293b;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

.modal-info-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 10px;
}


@media (max-width: 768px) {
  .modal-popup {
    width: 100%;
    padding: 15px;
  }

  .modal-header {
    font-size: 1.2em; 
    padding: 8px;
  }

  .modal-body,
  .modal-info-text {
    font-size: 0.9em; 
  }
}


@media (max-width: 480px) {
  .modal-popup {
    padding: 10px;
  }

  .modal-header {
    font-size: 1em;
  }

  .modal-body,
  .modal-info-text {
    font-size: 0.8em;
  }
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  color: #9ca3af;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

.form-group input {
  width: calc(100% - 10px);
  padding: 10px;
  background-color: #374151;
  border: 1px solid #4b5563;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  outline: none;
}

.form-group input:focus {
  border-color: #10b981;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-open .header--dark,
.modal-open footer {
  opacity: 0;
  pointer-events: none;
}
.form-group input[type="datetime-local"] {
  padding: 10px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #4b5563;
  background-color: #1f2937;
  color: #e5e7eb;
  outline: none;
}

.form-group input[type="datetime-local"]:focus {
  border-color: #00cc99;
  box-shadow: 0px 0px 8px rgba(0, 204, 153, 0.4);
}
.date-picker {
  background-color: #0e1726;
  color: white;
  border: 1px solid #4b5563;
  border-radius: 10px;
}

.form-group input,
.form-group select {
  width: calc(100% - 10px);
  padding: 10px;
  background-color: #374151;
  border: 1px solid #4b5563;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  outline: none;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #10b981;
}

</style>
